<template>
  <div
    data-v-show="order && order.OrderKey"
    class="cart_icon"
    :class="{ 'active-link': cartLinkActive }"
  >
    <i class="material-icons mr-1" @click.prevent="go(false)">shopping_cart</i>
    <em class="badge" v-show="order && order.OrderKey" :rel="order.CartCount">{{
      order.CartCount
    }}</em>

    <div class="cart_pop" v-show="!cartLinkActive">
      <article v-if="order && order.OrderKey && order.CartCount">
        <cart-icon-individual
          v-for="product in order.Individual"
          :key="'cart-icon-individual-' + product.OrderEntityKey"
          :product="product"
        />
        <cart-icon-package
          v-for="product in order.Packages"
          :key="'cart-icon-package-' + product.OrderPackageKey"
          :product="product"
        />
        <cart-icon-gift-card
          v-for="(product, i) in order.GiftCards.filter(item => !item.IsDeleted)"
          :key="'cart-icon-gift-card-' + product.OrderMerchandiseKey + '-' + i"
          :product="product"
        />

        <div class="cart_pop_subtotal">
          <strong>Subtotal</strong>
          <strong>
            <currency :fixed="true" :value="order.SubTotal" />
          </strong>
        </div>
        <a
          class="button blue text-center mb-0"
          href
          @click.prevent="go('checkout')"
          activeClass="active"
          >Checkout</a
        >
        <a
          class="button link text-center mb-0 mt-0 hide-at-medium"
          href
          @click.prevent="go(false)"
          activeClass="active"
          >Go to cart</a
        >
      </article>

      <article class="text-center" v-else>
        <i
          class="material-icons text-center mt-3 text-gray"
          style="font-size: 62px; opacity: .50"
          >remove_shopping_cart</i
        >
        <p class="text-center mt-1 mb-0">Your cart is empty.</p>
      </article>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import CartIconIndividual from "./CartIconIndividual.vue";
import CartIconPackage from "./CartIconPackage.vue";
import CartIconGiftCard from "./CartIconGiftCard.vue";

export default {
  name: "CartIcon",
  computed: {
    ...mapState(["order", "cartLinkActive"])
    //...mapGetters("productsInCart")
  },
  components: {
    CartIconIndividual,
    CartIconPackage,
    CartIconGiftCard
  },
  methods: {
    go(seg) {
      if (this.order && this.order.OrderKey && this.order.CartCount) {
        var path =
          "/" +
          this.$route.params.client +
          "/cart/" +
          this.order.OrderKey +
          (seg ? "/" + seg : "");
        //alert(seg);
        this.$router.push({
          path: path
        });
      }
    }
  }
};
</script>

<style></style>
